import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';

export default (onClickOutside) => (InnerComponent) => {
  class EnhancedComponent extends Component {
    handleClickOutside(e) {
      onClickOutside(e, this.props);
    }

    render() {
      return <InnerComponent {...this.props} />;
    }
  }

  const enhanced = enhanceWithClickOutside(EnhancedComponent);

  enhanced.displayName = `ClickOutside(${InnerComponent.name})`;
  return enhanced;
};



/** WEBPACK FOOTER **
 ** ./modules/click-outside/index.js
 **/